import { useMutation, useQueryClient } from "react-query";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

import { createBrainstormIdea } from "modules/collaboration/api/brainstorming";

import { CreateBrainstormIdeaDto } from "modules/collaboration/types/dto";
import { BrainstormIdea } from "modules/collaboration/types/entities";

import { BRAINSTORM_IDEAS_QUERY_KEY } from "../queries/useBrainstormIdeasQuery";
import { BRAINSTORM_IDEAS_STATS_QUERY_KEY } from "../queries/useBrainstormIdeasStatsQuery";

import { sendTrackingEvent } from "modules/core/api/tracking";
import { trackingEvents } from "modules/collaboration/config/tracking/events";

export const useCreateBrainstormIdeaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BrainstormIdea, AxiosError, CreateBrainstormIdeaDto>({
    mutationFn: createBrainstormIdea,
    onSettled: () => {
      queryClient.invalidateQueries(BRAINSTORM_IDEAS_QUERY_KEY);
      queryClient.invalidateQueries(BRAINSTORM_IDEAS_STATS_QUERY_KEY);
    },
    onSuccess: () => {
      sendTrackingEvent(trackingEvents.brainstorming_idea.created_idea);
    },
    onError: () => {
      showNotification({
        message: "Could not create brainstorm idea",
        color: "red"
      });
    }
  });
};
